module.exports = __webpack_public_path__ + "static/media/S_8.00b76cd7.png";